import CartItem from './CartItem'

export default CartItem



// WEBPACK FOOTER //
// ./src/features/Cart/components/CartItem/index.js